<div class="container">
    <div class="section-title">
        <span>Our Values</span>
        <h3>Value Engineering & More </h3>
    </div>
    <div class="row align-items-center">
        <div class="col-lg-4 col-md-6">
            <div class="process-item">
                <div class="process-image">
                    <img src="assets/img/process/1.png" alt="image">
                </div>
                <div class="process-content">
                    <h3>Project Management</h3>
                    <p>We provide a wide-range of project management applications from the initial project discovery
                        phase, budgeting, master planning, quality reviews and scheduling to procuring the right team
                        and executing the process through the close-out phase. </p>
                    <div class="process-btn">
                        <a routerLink="/category-details/1" class="process-btn-one">Read More <i
                            class="flaticon-right"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6">
            <div class="process-item">
                <div class="process-image">
                    <img src="assets/img/process/2.png" alt="image">
                </div>
                <div class="process-content">
                    <h3>Value Engineering</h3>
                    <p>When you partner with VE& More, you can expect both quality and value. Early in the design phase
                        of a construction project, the VE& More team works collaboratively with the client and architect
                        to apply value engineering techniques.</p>
                    <div class="process-btn">
                        <a routerLink="/category-details/2" class="process-btn-one">Read More <i
                            class="flaticon-right"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
            <div class="process-item">
                <div class="process-image">
                    <img src="assets/img/process/3.png" alt="image">
                </div>
                <div class="process-content">
                    <h3>Learn</h3>
                    <p>Overall, learning value engineering and achieving VMA certification provide individuals with
                        valuable knowledge, skills, and credentials. It enhances their professional capabilities, career
                        prospects, and ability to deliver value-driven solutions.</p>
                    <div class="process-btn">
                        <a routerLink="/category-details/3" class="process-btn-one">Read More <i
                            class="flaticon-right"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
